import languageApi from 'serviceWorker/api/language';
import { applyServiceWorkerConfig } from 'serviceWorker/services/config/applyServiceWorkerConfig';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { serviceWorkerConfigContract } from 'shared/domain/serviceWorkerConfig/serviceWorkerConfigContract';

/** Answers the page's config requests. */
export function serveServiceWorkerConfigRequests(): ChannelUnsubscribe {
  return channelServer.handle(serviceWorkerConfigContract, {
    set: applyServiceWorkerConfig,
    changeLanguage: languageApi.change,
  });
}
